const cases = [
  {
    route: "/japan",
    title: "WHAT I BROUGHT FROM JAPAN INSTEAD OF A FRIDGE MAGNET",
    description:
      "Last November I traveled around Japan, it was my first time visiting Asia.\n\nAs a European guy, I was extremely inspired and stimulated by all around me: Supermarkets, bullet trains, arcade games, museums, toilets, vending machines, people. I fell in love with Japanese lifestyle and culture. So much that I felt like\n\nI wanted to take everything with me.\nI honestly would have brought a giant Picachu vending machine with me if I could but that would have been an issue considering the size of my suitcase.\n\nInstead, as an avid collector, I decided to start documenting all the objects that  triggered my creativity. Some of them iconic, like the everpresent vending machines, and some others just mementoes of my travels like bullet train tickets, postcards or arcade game vouchers. \n\nThis collection of images was the ground for my motion artworks. I created my own personal souvenirs.Photography had a clear function during this process. It was transformative. Through motion design I was able to display this collection as part of what came to be a visual fieldwork.\n\nWhat seemed like trash for a regular traveler, became the most important memories for me. All those artifacts were connected to what I went through on my trip. And going back to them allowed me to notice details that previously escaped my eyes.Static images were brought to life through motion and sound. I compulsively recorded sounds from their surroundings, and simulated their natural atmosphere. \n\nThe sound of vending machines created an immersive experience pairing with the bold visual effects to show the incredible level of consumption. Sound and image blend in a hectic yet peaceful dynamic.",
    folder: "/mediawebm/japan",
    images: [
      "1.webp",
      "2.webm",
      "3.webm",
      "4.webm",
      "5.webm",
      "6.webm",
      "7.webm",
      "8.webm",
      "9.webm",
      "10.webm",
    ],
  },
  {
    route: "/blue-hawaii",
    title: "BLUE HAWAII\nIMMERSIVE VISUAL EXPERIENCE",
    description:
      "Relaxing digital journey through the beauty of 'Blue Hawaii.' This motion captures the natural charm of the islands, offering a calming escape.\n\nAs you explore this abstract world, you'll be greeted by the soothing blue tones of the ocean, the gentle roll of waves and immersive movement showing the deepness.\n\nThe visual is carefully synchronised with a Canadian electronic music duo Blue Hawaii soundtrack. Together, they offer a simple yet captivating glimpse into the natural wonders that make Hawaii a destination for relaxation and reflection.",
    folder: "/mediawebm/blue-hawaii",
    images: ["1.webm", "2.webm", "3.webm", "4.webm"],
  },
  {
    route: "/oplich",
    title: "O–PLICH–® POBUT DROP",
    description:
      "Mood video for the design community O–PLICH– with the aim to help Ukraine, along with giving the world a unique product, which represents Ukrainian culture, customs, and way of living. We worked with multiple layers of photographs and vector graphics, textures and various motion patterns + developed the sound part, highlighting the dynamics.",
    folder: "/mediawebm/oplich",
    images: [
      "1.jpeg",
      "2.jpeg",
      "3.jpeg",
      "4.jpeg",
      "5.jpeg",
      "6.jpeg",
      "7.jpeg",
      "8.jpeg",
      "9.jpeg",
      "10.jpeg",
      "11.jpeg",
      "12.png",
      "13.jpeg",
    ],
  },
  {
    route: "/puma",
    title: "PUMA X FC SHAKHTAR",
    description:
      "German sports brand PUMA presented home and away uniform sets for the Ukrainian football club Shakhtar (season 2021/2022). The presentation took place in a live broadcast with the participation of club representatives and fans. My role as a motion designer was to animate the logo shot for the film and the background video for the screen on the floor to make the event even more spectacular.",
    folder: "/mediawebm/puma",
    images: [
      "1.webm",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.jpg",
      "6.webp",
      "7.webp",
      "8.webp",
    ],
  },
];

export default cases;